import {
	BodyBasic,
	BodyBg,
	BodyBullet,
	BodyLineBorder,
	BodyFrameIcon,
	BodyCornerBracket,
	BodyLeftBar,
	BodySplitHeader,
	BodyLineBadge,
	BodySolid,
	BodyNoticeBox,
	BodyIndexSide,
	BodyDashedTitle,
	BodyOutline,
	BodyBarPanel,
	BodyGrayTip,
	BodyLineDotLeft,
	BodyLineDotRight,
	BodyBracketLine,
} from './Body/index.js';
import {
	DividerThin,
	DividerThick,
	DividerDoubleMixed,
	DividerDoubleThickTop,
	DividerGradient,
	DividerDashed,
	DividerDashedDense,
	DividerDashedSparse,
	DividerCenterSquares,
	DividerCenterDiamond,
	DividerGrayBar,
} from './Divider/index.js';
import {
	TitleBasic,
	TitleDiamond,
	TitleFaq,
	TitleBrand,
	TitleTag,
	TitleUnderline,
	TitlePill,
	TitleSidebarEn,
	TitleSidebar,
	TitleStack,
	TitleStackReverse,
	TitleEnLead,
	TitleLeftLead,
	TitleCenterUnderline,
	TitleCenterStack,
	TitleCenterDivider,
	TitleFullLine,
	TitleCenterBar,
	TitleArticle,
	TitleHeading,
	TitleTrailLine,
	TitleThickUnderline,
	TitleCenterRail,
	TitleCenterBreak,
	TitleBadge,
	TitleFramed,
	TitleDoubleLine,
	TitleRecruitCard,
	TitleLeftBar,
	TitleLeftBarBg,
	TitleCenterSideLine,
	TitleSlantBlock,
	TitleBoxAccent,
	TitleSplitBox,
	TitleSlantTag,
	TitleSlantLines,
	TitleBoxSideLine,
	TitleDiamondAccent,
} from './Title/index.js';
import PayUnlockClassic from './PayUnlock/variants/Classic.vue';
import PayUnlockTrial from './PayUnlock/variants/Trial.vue';
import PayUnlockLimited from './PayUnlock/variants/Limited.vue';
import PayUnlockPack from './PayUnlock/variants/Pack.vue';
import PayUnlockCommunity from './PayUnlock/variants/Community.vue';
import PayUnlockImage from './PayUnlock/variants/Image.vue';
import PayUnlockOverseas from './PayUnlock/variants/Overseas.vue';
import PayUnlockCreator from './PayUnlock/variants/Creator.vue';
import PayUnlockMystery from './PayUnlock/variants/Mystery.vue';
import PayUnlockJumpLink from './PayUnlock/variants/JumpLink.vue';
import PayUnlockJumpLinkPlus from './PayUnlock/variants/JumpLinkPlus.vue';
import PayUnlockJumpLinkFeatured from './PayUnlock/variants/JumpLinkFeatured.vue';
import PayUnlockJumpLinkCourse from './PayUnlock/variants/JumpLinkCourse.vue';
import PayUnlockJumpLinkAdvance from './PayUnlock/variants/JumpLinkAdvance.vue';
import PayUnlockJumpLinkUnlock from './PayUnlock/variants/JumpLinkUnlock.vue';
import PayUnlockJumpLinkViewAll from './PayUnlock/variants/JumpLinkViewAll.vue';
import PayUnlockJumpLinkBar from './PayUnlock/variants/JumpLinkBar.vue';
import {
	QrcodeNavSolid,
	QrcodeNavGradient,
	QrcodeNavOutline,
	QrcodeNavCell,
	QrcodeNavCard,
	QrcodeNavList,
	QrcodeNavBanner,
	QrcodeNavLink,
	QrcodeNavGrid,
} from './QrcodeNav/index.js';
import { QuickNavGrid } from './QuickNav/index.js';

import {
	ImageGrid,
	ImageCard,
	ImageFeatureCard,
	ImageCollage,
	ImageTrio,
	ImageMosaic,
	ImageQuad,
	ImageHeader,
} from './Image/index.js';

import { VideoList, VideoRow, AudioLibrary, AudioPlayer, AudioHeader, VideoHeader } from './Media/index.js';
import { PayImageGallery, PayImageWall } from './PayImage/index.js';
import { PayFileUnlock, PayFileList, PayFileCollection } from './PayFile/index.js';
import { PayAudioPlayer, PayAudioLibrary, PayAudioPlaylist, PayVideoPlayer, PayVideoList, PayVideoSeries } from './PayMedia/index.js';
import { FileHeader } from './File/index.js';
import { ContactInfo } from './Contact/index.js';
import { RichText } from './RichText/index.js';

/** 区块 type -> 组件（渲染与编辑共用，通过 editable 区分模式） */
const BLOCK_MAP = {
	'title-basic': TitleBasic,
	'title-diamond': TitleDiamond,
	'title-faq': TitleFaq,
	'title-brand': TitleBrand,
	'title-tag': TitleTag,
	'title-underline': TitleUnderline,
	'title-pill': TitlePill,
	'title-sidebar-en': TitleSidebarEn,
	'title-sidebar': TitleSidebar,
	'title-stack': TitleStack,
	'title-stack-reverse': TitleStackReverse,
	'title-en-lead': TitleEnLead,
	'title-left-lead': TitleLeftLead,
	'title-center-underline': TitleCenterUnderline,
	'title-center-stack': TitleCenterStack,
	'title-center-divider': TitleCenterDivider,
	'title-full-line': TitleFullLine,
	'title-center-bar': TitleCenterBar,
	'title-article': TitleArticle,
	'title-h1': TitleHeading,
	'title-h2': TitleHeading,
	'title-h3': TitleHeading,
	'title-h4': TitleHeading,
	'title-h5': TitleHeading,
	'title-h6': TitleHeading,
	'title-trail-line': TitleTrailLine,
	'title-thick-underline': TitleThickUnderline,
	'title-center-rail': TitleCenterRail,
	'title-center-break': TitleCenterBreak,
	'title-badge': TitleBadge,
	'title-framed': TitleFramed,
	'title-double-line': TitleDoubleLine,
	'title-recruit-card': TitleRecruitCard,
	'title-left-bar': TitleLeftBar,
	'title-left-bar-bg': TitleLeftBarBg,
	'title-center-side-line': TitleCenterSideLine,
	'title-slant-block': TitleSlantBlock,
	'title-box-accent': TitleBoxAccent,
	'title-split-box': TitleSplitBox,
	'title-slant-tag': TitleSlantTag,
	'title-slant-lines': TitleSlantLines,
	'title-box-side-line': TitleBoxSideLine,
	'title-diamond-accent': TitleDiamondAccent,
	'body-basic': BodyBasic,
	'body-bg': BodyBg,
	'body-bullet': BodyBullet,
	'body-line-border': BodyLineBorder,
	'body-frame-icon': BodyFrameIcon,
	'body-corner-bracket': BodyCornerBracket,
	'body-left-bar': BodyLeftBar,
	'body-split-header': BodySplitHeader,
	'body-line-badge': BodyLineBadge,
	'body-solid': BodySolid,
	'body-notice-box': BodyNoticeBox,
	'body-index-side': BodyIndexSide,
	'body-dashed-title': BodyDashedTitle,
	'body-outline': BodyOutline,
	'body-bar-panel': BodyBarPanel,
	'body-gray-tip': BodyGrayTip,
	'body-line-dot-left': BodyLineDotLeft,
	'body-line-dot-right': BodyLineDotRight,
	'body-bracket-line': BodyBracketLine,
	'divider-thin': DividerThin,
	'divider-thick': DividerThick,
	'divider-double-thick-top': DividerDoubleThickTop,
	'divider-double-mixed': DividerDoubleMixed,
	'divider-gradient': DividerGradient,
	'divider-dashed': DividerDashed,
	'divider-dashed-dense': DividerDashedDense,
	'divider-dashed-sparse': DividerDashedSparse,
	'divider-center-squares': DividerCenterSquares,
	'divider-center-diamond': DividerCenterDiamond,
	'divider-gray-bar': DividerGrayBar,
	'pay-unlock': PayUnlockClassic,
	'pay-unlock-trial': PayUnlockTrial,
	'pay-unlock-limited': PayUnlockLimited,
	'pay-unlock-pack': PayUnlockPack,
	'pay-unlock-community': PayUnlockCommunity,
	'pay-unlock-image': PayUnlockImage,
	'pay-unlock-overseas': PayUnlockOverseas,
	'pay-unlock-creator': PayUnlockCreator,
	'pay-unlock-mystery': PayUnlockMystery,
	'pay-unlock-jumplink': PayUnlockJumpLink,
	'pay-unlock-jumplink-plus': PayUnlockJumpLinkPlus,
	'pay-unlock-jumplink-featured': PayUnlockJumpLinkFeatured,
	'pay-unlock-jumplink-course': PayUnlockJumpLinkCourse,
	'pay-unlock-jumplink-advance': PayUnlockJumpLinkAdvance,
	'pay-unlock-jumplink-unlock': PayUnlockJumpLinkUnlock,
	'pay-unlock-jumplink-viewall': PayUnlockJumpLinkViewAll,
	'pay-unlock-jumplink-bar': PayUnlockJumpLinkBar,
	'qrcode-nav-solid': QrcodeNavSolid,
	'qrcode-nav-gradient': QrcodeNavGradient,
	'qrcode-nav-outline': QrcodeNavOutline,
	'qrcode-nav-cell': QrcodeNavCell,
	'qrcode-nav-card': QrcodeNavCard,
	'qrcode-nav-list': QrcodeNavList,
	'qrcode-nav-banner': QrcodeNavBanner,
	'qrcode-nav-link': QrcodeNavLink,
	'qrcode-nav-grid': QrcodeNavGrid,
	'quick-nav-grid': QuickNavGrid,
	'image-grid': ImageGrid,
	'image-card': ImageCard,
	'image-feature-card': ImageFeatureCard,
	'image-collage': ImageCollage,
	'image-trio': ImageTrio,
	'image-mosaic': ImageMosaic,
	'image-quad': ImageQuad,
	'image-header': ImageHeader,
	'file-header': FileHeader,
	'video-list': VideoList,
	'video-row': VideoRow,
	'audio-library': AudioLibrary,
	'audio-player': AudioPlayer,
	'audio-header': AudioHeader,
	'video-header': VideoHeader,
	'contact-info': ContactInfo,
	'rich-text': RichText,
	'pay-image-gallery': PayImageGallery,
	'pay-image-wall': PayImageWall,
	'pay-file-unlock': PayFileUnlock,
	'pay-file-list': PayFileList,
	'pay-file-collection': PayFileCollection,
	'pay-audio-player': PayAudioPlayer,
	'pay-audio-library': PayAudioLibrary,
	'pay-audio-playlist': PayAudioPlaylist,
	'pay-video-player': PayVideoPlayer,
	'pay-video-list': PayVideoList,
	'pay-video-series': PayVideoSeries,
};

export function getBlockComponent(type) {
	return BLOCK_MAP[type] || null;
}

export { BLOCK_MAP };
